"use client";

import { sanitiseTerms } from "@/utils/product/sanitiseTerms";
import { AccordionItem } from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/accordion-item/AccordionItem";
import { useState } from "react";
import { ProductAccordionWithMonetateEvents } from "../../ProductAccordionWithMonetateEvents";
import baseStyles from "../../ProductAccordion.module.scss";
export const PRODUCT_RETURNS_ACCORDION_INSTANCE_NAME = "product-returns";

type Props = {
  terms: string;
  open?: boolean;
};

export function ProductReturnsAccordionUI({ terms, open }: Props) {
  const productReturnsLabel: string | React.JSX.Element =
    "Returns and exchange policy";
  const [isOpen, setIsOpen] = useState(open);
  const sanitisedTerms = sanitiseTerms(terms);

  return (
    <ProductAccordionWithMonetateEvents name="Returns" open={isOpen}>
      <AccordionItem
        id="ratings-reviews-section"
        data-testid="accordion:returns"
        header={
          <h2 className={baseStyles.accordionTitle}>{productReturnsLabel}</h2>
        }
        instanceName={PRODUCT_RETURNS_ACCORDION_INSTANCE_NAME}
        isOpen={open}
        onStateChange={(isOpen: boolean) => {
          setIsOpen(isOpen);
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: sanitisedTerms }}></div>
      </AccordionItem>
    </ProductAccordionWithMonetateEvents>
  );
}
